<template>
  <div class="index">
    <div class="index_title animate__animated animate__zoomIn">
      提供专业服务 一站式解决用户需求
    </div>

    <!-- <VideoMedia></VideoMedia> -->
    <div class="index_about animate__animated animate__fadeInUpBig">
      <div class="index_about_item" v-for="(item, index) in about" :key="index">
        <div class="index_about_item_bg">“{{ item.bg }}</div>
        <div class="index_about_item_title">{{ item.title }}</div>
        <div class="index_about_item_dec">{{ item.dec }}</div>
      </div>
    </div>

    <div
      id="产品业务"
      class="wow index_title animate__animated animate__zoomIn"
    >
      服务项目
    </div>
    <div class="produce_bg">
      <div class="wow product_mobile animate__animated animate__fadeInUpBig">
        <div v-for="(item, index) in seller" :key="index" class="product_item">
          <i :class="['iconfont', item.icon]" style="font-size: 60px"></i>
          <div class="product_item_name">{{ item.name }}</div>
          <div class="product_line"></div>
          <div class="product_item_brif">{{ item.brief }}</div>
          <div class="product_item_btn" @click="goToRoute(item)">了解更多</div>
        </div>
      </div>
    </div>

    <!-- 产品特点-->
    <div
      id="产品业务"
      class="wow index_title animate__animated animate__zoomIn"
    >
      服务体系以及流程
    </div>

    <div class="index_server">
      <div class="wow index_server_con animate__animated animate__fadeInUpBig">
        <div class="index_server_tab">
          <div
            :class="[
              'index_server_tab_item',
              tabIndex == item.id ? 'index_server_tab_item_active' : '',
            ]"
            v-for="(item, index) in server"
            :key="index"
            @mouseenter="chooseTab(item.id)"
          >
            {{ item.tab }}
          </div>
        </div>
        <div class="index_server_tab_con">
          <div class="tab_text">
            <div class="tab_text_title">{{ server[tabIndex - 1].title }}</div>
            <div class="tab_text_detail">{{ server[tabIndex - 1].detail }}</div>
          </div>
          <div class="tab_img">
            <div class="tab_img_con" v-show="tabIndex == 1">
              <div
                class="tab_con_item"
                v-for="(item, index) in flowPath"
                :key="index"
              >
                <div class="tab_img_item">
                  <img
                    style="width: 72px; height: 83px"
                    src="../../static/other/new_rank.png"
                    alt=""
                  />
                  <div class="tab_img_num">{{ index + 1 }}</div>
                  <img
                    class="tab_img_arrow"
                    v-if="index != 5"
                    src="../../static/other/arrow_right.png"
                    alt=""
                  />
                </div>
                <div>{{ item.flow }}</div>
                <img style="width: 60px; height: 60px" :src="item.img" alt="" />
              </div>
            </div>
            <div class="tab_img_con" v-show="tabIndex == 2">
              <img src="../../static/other/pic-3.jpg" alt="" />
            </div>
            <div class="tab_img_con" v-show="tabIndex == 3">
              <img src="../../static/other/pic-2.png" alt="" />
            </div>
            <div class="tab_img_con" v-show="tabIndex == 4">
              <img src="../../static/other/pic-1.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="合作伙伴" class="parter_all">
      <div
        class="index_title wow animate__animated animate__zoomIn"
        style="margin-top: 0px"
      >
        合作伙伴
      </div>
      <div class="parter_con wow animate__animated animate__fadeInUpBig">
        <div class="parter">
          <el-carousel
            height="250px"
            :interval="3000"
            indicator-position="none"
          >
            <el-carousel-item
              v-for="(item, index) in parter"
              :key="index"
              style="padding: 20px; box-sizing: border-box"
            >
              <div class="parter_item">
                <div
                  @click="go(picItem.link)"
                  class="parter_item_img"
                  v-for="(picItem, index2) in item"
                  :key="index2"
                >
                  <img :src="picItem.src" alt="" />
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 合作伙伴-->

    <div class="friendly_link">
      <div class="friendly_link_con">
        <div class="friendly_link_title">友情链接：</div>
        <div class="friendly_link_name">
          <div
            class="friendly_item"
            v-for="(item, index) in friendlyArr"
            :key="index"
            @click="go(item.link)"
          >
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 关于我们-->
    <!-- <div id="资讯动态" class="index_title wow animate__animated animate__zoomIn">
            资讯动态
        </div>
        <div class="wow about_news animate__animated animate__fadeInUpBig">
            <div class="about_news_item" v-for="(item,index) in newsList" :key="index" >
                <div class="about_news_title">{{ item.title }}</div>
                <div class="about_news_detail">{{ item.detail }}</div>
                <div class="about_news_bot">
                    <div class="about_news_time">
                        <span>04.16</span>
                        <span></span>
                        <span>2023</span>

                    </div>
                    <div class="about_news_link" >查看></div>
                </div>
            </div>
        </div> -->

    <!-- <div class="btn" @click="login">立即投保</div> -->
  </div>
</template>
<script>
// import VideoMedia from './VideoMedia.vue';
export default {
  name: "Index",
  data() {
    return {
      spec: {
        img: require("../../static/other/arrow.png"),
      },
      company: [
        "企业从事于：互联网整合营销，互联网软件开发，微信公众号，小程序，微商城开发，提供技术支持，是所创业型服务研发公司。",
        "核心理念：打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。",
        "团队作风：我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
        "企业精神：以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。",
      ],
      parter: [
        [
          {
            name: "中国平安",
            src: require("../../static/parter/p-9.jpg"),
            link: "https://www.pingan.com",
          },
          {
            name: "华商",
            src: require("../../static/parter/p-25.jpg"),
            link: "https://www.cmbcn.com.cn/",
          },
          {
            name: "中国人民",
            src: require("../../static/parter/p-19.jpg"),
            link: "https://www.picc.com/",
          },
          {
            name: "中国人寿",
            src: require("../../static/parter/p-20.jpg"),
            link: "https://www.chinalife.com.cn/chinalife/index/",
          },
          {
            name: "华泰",
            src: require("../../static/parter/p-23.png"),
            link: "https://www.ehuatai.com/",
          },
          {
            name: "紫金保险",
            src: require("../../static/parter/p-10.png"),
            link: "http://www.zking.com",
          },
          {
            name: "安华农业保险",
            src: require("../../static/parter/p-12.png"),
            link: "http://www.ahic.com.cn/",
          },
          {
            name: "国任保险",
            src: require("../../static/parter/p-15.png"),
            link: "https://www.guorenpcic.com/",
          },
        ],
        [
          {
            name: "内蒙产权交易市场",
            src: require("../../static/parter/p-3.png"),
            link: "http://nmgcqjy.ejy365.com/",
          },
          {
            name: "内蒙住建",
            src: require("../../static/parter/p-30.png"),
            link: "http://zjt.nmg.gov.cn/",
          },
          {
            name: "中国通用招标网",
            src: require("../../static/parter/p-32.png"),
            link: "https://www.china-tender.com.cn/",
          },
          {
            name: "内蒙招标采购",
            src: require("../../static/parter/p-31.png"),
            link: "https://imbpa.nmgztb.com.cn/",
          },
          {
            name: "比德电子采购平台",
            src: require("../../static/parter/p-8.png"),
            link: "https://www.bdebid.com/",
          },
          {
            name: "新疆和田公共资源交易中心",
            src: require("../../static/parter/p-38.jpg"),
            link: "http://ggzy.xjht.gov.cn:8081/",
          },
          {
            name: "中航发",
            src: require("../../static/parter/p-42.jpg"),
            link: "https://ebidding.aecc-mall.com/cms/index.htm",
          },

          {
            name: "华电",
            src: require("../../static/parter/p-41.png"),
            link: "https://www.chdtp.com/",
          },

        ],


        [
          {
            name: "中国平安",
            src: require("../../static/parter/p-9.jpg"),
            link: "https://www.pingan.com",
          },
          {
            name: "华商",
            src: require("../../static/parter/p-25.jpg"),
            link: "https://www.cmbcn.com.cn/",
          },
          {
            name: "中国人民",
            src: require("../../static/parter/p-19.jpg"),
            link: "https://www.picc.com/",
          },
          {
            name: "中国人寿",
            src: require("../../static/parter/p-20.jpg"),
            link: "https://www.chinalife.com.cn/chinalife/index/",
          },
          {
            name: "华泰",
            src: require("../../static/parter/p-23.png"),
            link: "https://www.ehuatai.com/",
          },
          {
            name: "紫金保险",
            src: require("../../static/parter/p-10.png"),
            link: "http://www.zking.com",
          },
          {
            name: "安华农业保险",
            src: require("../../static/parter/p-12.png"),
            link: "http://www.ahic.com.cn/",
          },
          {
            name: "国任保险",
            src: require("../../static/parter/p-15.png"),
            link: "https://www.guorenpcic.com/",
          },
        ],
        [
          {
            name: "内蒙产权交易市场",
            src: require("../../static/parter/p-3.png"),
            link: "http://nmgcqjy.ejy365.com/",
          },
          {
            name: "内蒙住建",
            src: require("../../static/parter/p-30.png"),
            link: "http://zjt.nmg.gov.cn/",
          },
          {
            name: "中国通用招标网",
            src: require("../../static/parter/p-32.png"),
            link: "https://www.china-tender.com.cn/",
          },
          {
            name: "内蒙招标采购",
            src: require("../../static/parter/p-31.png"),
            link: "https://imbpa.nmgztb.com.cn/",
          },
          {
            name: "比德电子采购平台",
            src: require("../../static/parter/p-8.png"),
            link: "https://www.bdebid.com/",
          },
          {
            name: "新疆和田公共资源交易中心",
            src: require("../../static/parter/p-38.jpg"),
            link: "http://ggzy.xjht.gov.cn:8081/",
          },
          {
            name: "中航发",
            src: require("../../static/parter/p-42.jpg"),
            link: "https://ebidding.aecc-mall.com/cms/index.htm",
          },

          {
            name: "华电",
            src: require("../../static/parter/p-41.png"),
            link: "https://www.chdtp.com/",
          },

        ],
      ],
      newsList: [
        {
          title:
            "我是资讯的标题巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙",
          detail:
            "我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容",
          time: "2023-1-1",
        },
        {
          title:
            "我是资讯的标题巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙",
          detail:
            "我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容",
          time: "2023-1-1",
        },
        {
          title:
            "我是资讯的标题巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙",
          detail:
            "我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容",
          time: "2023-1-1",
        },
        {
          title:
            "我是资讯的标题巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙巴拉巴拉吧小魔仙",
          detail:
            "我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容我是内容",
          time: "2023-1-1",
        },
      ],
      seller: [
        {
          tabIndex: "1",
          name: "投标保函",
          icon: "icon-toubiao",
          brief:
            "投标人购买投标保函等同于缴纳投标保证金，是在通过招采方式成交的工程建造项目中，投标方为响应招标方的要求，向保证人申请出具的保函，保证投标方履行招标文件的一种保函",
        },
        {
          tabIndex: "2",
          name: "合同履约保函",
          icon: "icon-hetong",
          brief:
            "向建设工程发包人提供的保证承包人履行建设合同义务的保函，是担保人应被保证人申请向工程承包项目中的业主出具的，保证被保证人严格按照合同约定全面和实际地履行其合同责任和义务的一种保函。",
        },
        {
          tabIndex: "3",
          name: "工程款支付保函",
          icon: "icon-zhifudingjin",
          brief:
            "是指保证人为承包方向发包方提供的，在发包方预先支付一定数额款项以供承包方周转使用后，保证承包方在收到预付款后按施工合同约定专款专用的一种担保。",
        },
        {
          tabIndex: "4",
          name: "工程质量保函",
          icon: "icon-icon-zhiliangguanli",
          brief:
            "工程质量保函，也称为“维修保函”，是指应供货方或承建人申请，向买方或业主保证，如货物或工程的质量不符合合同约定而卖方或承建人又不能依约更换或修理时，按买方或业主的索赔予以赔偿的书面文件。质量保函",
        },
        {
          tabIndex: "5",
          name: "预付款保函",
          icon: "icon-gongyingshangyufukuan",
          brief:
            "是指保证人为承包方向发包方提供的，在发包方预先支付一定数额款项以供承包方周转使用后，保证承包方在收到预付款后按施工合同约定专款专用的一种担保。",
        },
        {
          tabIndex: "6",
          name: "农民工工资支付保函",
          icon: "icon-shigongrenyuan",
          brief:
            "是指在建筑工程项目中为保证建设单位如期履行工人工资支付义务，由担保人为建设单位向监管人提供的，保证建设单位如期履行工人工资支付义务的担保。",
        },
      ],
      about: [
        { title: "模式创新", dec: "三合一担保体系", bg: "创" },
        { title: "企业减负", dec: "节省投标时间成本", bg: "减" },
        { title: "方便快捷", dec: "分钟级别快速出函", bg: "快" },
        { title: "安全保密", dec: "全程电子留痕可追溯", bg: "安" },
      ],
      server: [
        {
          id: 1,
          tab: "线上申请流程",
          title: "全流程线上电子保函申请",
          detail:
            "操作简便，手续简单，1分钟完成保函申请，无需抵押。全流程线上化，前端渠道全对接，电子出函，与纸质保函同等法律效力；审批、用印、打印全流程线上化。",
          img: "",
        },
        {
          id: 2,
          tab: "平台产品体系",
          title: "项目全流程保函产品",
          detail:
            "平台保险保函、银行保函、担保保函全覆盖，依托高度的专业性，打造品类丰富的保函产品，鼎函通过“业务专家+技术研发专家”团队实现了保函产品定制化服务。",
          img: "",
        },
        {
          id: 3,
          tab: "售前售后服务",
          title: "售前售后答疑解惑",
          detail:
            "以需求为导向，量身定制保函产品售前解决方案；7×24小时售后客服在线、客户微信群服务，全面高效的解决能力。",
          img: "",
        },
        {
          id: 4,
          tab: "服务数据安全",
          title: "一站式电子保函数据管理",
          detail:
            "在线查询真伪，假保函无处遁形；支持在线查验保函状态，加章保函的查阅。信息安全，投标项目保密，涉及到关键的信息，进行开标前加密、开标自动解密处理。",
          img: "",
        },
      ],
      flowPath: [
        { img: require("../../static/other/icon_step1.png"), flow: "用户登录" },
        {
          img: require("../../static/other/icon_step2.png"),
          flow: "获取项目信息",
        },
        { img: require("../../static/other/icon_step3.png"), flow: "申请保函" },
        {
          img: require("../../static/other/icon_step4.png"),
          flow: "选择出函机构",
        },
        { img: require("../../static/other/icon_step5.png"), flow: "开具成功" },
        { img: require("../../static/other/icon_step6.png"), flow: "用户评价" },
      ],
      friendlyArr: [
        {
          name: "中国发展改革委员会",
          link: "https://www.ndrc.gov.cn/index.html",
        },
        {name:'国务院国有资产监督管理委员会',link:'http://www.sasac.gov.cn/'},
        { name: "中国企业国有产权交易机构协会", link: "http://www.cspea.org.cn/" },
        // {
        //   name: "地方国资委",
        //   link: "http://www.sasac.gov.cn/n4422011/n17627531/c17633273/content.html",
        // },
        { name: "中国通用技术集团", link: "https://www.gt.cn/" },
        { name: "内蒙古产权交易中心", link: "http://www.nmcqjy.com/" },
        // { name: "农村产权协会", link: "" },
      ],

      tabIndex: 1,
    };
  },
  components: {
    // VideoMedia

  },
  methods: {
    login() {
      window.open("https://tb.dinghanwang.com/login");
    },
    chooseTab(id) {
      this.tabIndex = id;
    },
    go(url) {
      window.open(url);
    },
    goToRoute(item) {
      let path = "/pc/produce",
        tabIndex = item.tabIndex;
      this.$router.push({ path, query: { tabIndex } });
    },

  },
  created() {},
  mounted() {
    new this.$wow.WOW().init();
  },

  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "550px";
      } else {
        return "250px";
      }
    },
    computeArrowImg() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 450) {
        return require("../../static/other/arrow.png");
      } else {
        return require("../../static/other/arrow_down.png");
      }
    },
  },
};
</script>

<style scoped>
.index {
  width: 100%;
}

.index_about {
  width: 100%;
  background: #fff;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.index_about_item {
  width: 300px;
  height: 200px;
  background: #b4e0f9;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-right: 10px;
  position: relative;
}
.index_about_item:hover .index_about_item_bg {
  animation: pulse;
  animation-duration: 1s;
}
.index_about_line {
  width: 1px;
  height: 80%;
  background-color: #bababa;
}
.index_about_item_bg {
  font-size: 80px;
  position: absolute;
  color: #fff;
  top: 2px;
  right: 5px;
}

.index_about_item_title {
  font-size: 28px;
  position: absolute;
  top: 40%;
  left: 10%;
}
.index_about_item_dec {
  font-size: 18px;
  position: absolute;
  top: 67%;
  left: 20%;
  color: #5a5a5a;
}
.index_title {
  width: 100%;
  text-align: center;
  font-size: 40px;
  margin: 100px 0 50px 0;
}

.cooperation {
  margin-top: 30px;
  width: 100%;
}

.about_me {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 100%;
}
.produce_bg {
  width: 100%;
  background-image: url(../../static/other/bg-line3.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(4px);
}
.product_mobile {
  display: flex;
  width: 1200px;
  flex-wrap: wrap;
  margin: auto;
  justify-content: space-between;
}

.product_item {
  width: 360px;
  height: 400px;
  background: rgb(255, 255, 255);
  color: rgb(26, 127, 221);
  cursor: pointer;
  margin-bottom: 20px;
  /* box-shadow: 0 2px 8px rgba(0,0,0,.15); */
  box-shadow: inset 0 0 0 0 rgb(237, 237, 238), 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  transition: color 0.5s ease-in-out, box-shadow 0.5s ease-in-out;
}
.product_item:hover {
  box-shadow: inset 360px 0 0 0 rgb(26, 127, 221), 0 2px 8px rgba(0, 0, 0, 0.15);
  color: white;
}
.product_item:hover .product_item_btn {
  border: 2px solid rgb(255, 255, 255);
  animation: bounceIn;
  animation-duration: 1.4s;
  animation-delay: 0.2s;
}
.product_item:hover .product_item_name {
  color: #ffffff;
}
.product_item:hover .product_item_brif {
  color: #ffffff;
}

.product_item_name {
  font-size: 24px;
  margin-top: 20px;
  color: #00041a;
}
.product_item_brif {
  color: #767c8c;
}
.product_item_btn {
  border-radius: 22px;
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border: 2px solid rgb(26, 127, 221);
  position: absolute;
  bottom: 35px;
  font-size: 14px;
}
.product_line {
  width: 90%;
  height: 1px;
  background: #eee9e9;
  margin: 20px 0;
}

.index_server {
  width: 100%;
  /* background: #b4e0f9 */
}
.index_server_con {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  background: #fff;
  width: 1200px;
  min-height: 100px;
  margin: auto;
}
.index_server_tab {
  width: 100%;
  display: flex;
  border-top: 1px solid #f0f0f0;
  border-right: 1px solid #f0f0f0;
  box-sizing: border-box;
}
.index_server_tab_item {
  background: #fff;
  flex-grow: 1;
  text-align: center;
  height: 50px;
  line-height: 50px;
  border-left: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  color: #666;
}
.index_server_tab_item_active {
  background: rgb(26, 127, 221);
  color: #fff;
}
.index_server_tab_con {
  width: 100%;
  height: 453px;
  display: flex;
  padding: 58px;
  box-sizing: border-box;
  gap: 50px;
  border: 1px solid #f0f0f0;
  border-top: 0;
}
.tab_text {
  width: 32%;
  height: 100%;
  background: #fff;
  border-radius: 10px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.tab_text_title {
  font-size: 26px;
  color: #202d40;
  font-weight: 600;
  margin-bottom: 30px;
}
.tab_text_detail {
  font-size: 16px;
  color: #53607f;
}
.tab_img {
  width: 68%;
  height: 100%;
}
.tab_img > img {
  width: 100%;
  height: 100%;
}
.tab_img_con {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.tab_con_item {
  width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 34px;
}
.tab_img_item {
  width: 72px;
  height: 83px;
  position: relative;
}
.tab_img_arrow {
  width: 20px;
  height: 20px;
  position: absolute;
  right: -30px;
  top: 30px;
}
.tab_img_num {
  width: 72px;
  height: 83px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 30px;
  font-weight: 600;
  color: #fff;
}
.ten_tagline,
.ten_tagline--fill {
  font-family: "TencentSansw7";
  overflow: hidden;
  font-size: 14px;
  line-height: 24px;
  height: 30px;
  display: inline-block;
  position: relative;
  border-top: 1px solid #0052d9;
  padding: 0px 30px;
  color: #0052d9;
}
.ten_tagline:before,
.ten_tagline--fill:before {
  content: "";
  display: block;
  position: absolute;
  left: calc(100% - 12px);
  bottom: 0px;
  width: 100%;
  border-top: 1px solid #0052d9;
  transform: rotate(-69deg) translate(-1px, 0px);
  transform-origin: 0px 0px;
}
.ten_tagline:after,
.ten_tagline--fill:after {
  content: "";
  display: block;
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: calc(100% - 12px);
  border-top: 1px solid #0052d9;
}
/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    height: auto;
    background: #f2f6fc;
  }

  .head-label {
    display: flex;
    margin-top: 10px;
  }

  .about_me {
    display: flex;
    margin-top: 10px;
    width: 100%;
  }
}

.font_size_24 {
  font-size: 1.5em;
}
.parter_all {
  width: 100%;
  height: 450px;
  background: #f7f7f7;
  padding-top: 100px;
  /* background-image: url(../../static/other/collaborate_bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%; */
}
.parter_con {
  width: 1200px;
  margin: auto;
  min-height: 180px;
}
.parter {
  width: 1200px;
  background: rgb(255, 255, 255);
  height: 263px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.parter_item {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;
  gap: 20px;
}
.parter_item_img {
  width: calc(100% / 4 - 20px);
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  /* background: linear-gradient(180deg, #F5F6FA 0%, #FFFFFF 100%); */
}
.parter_item img {
  width: 70%;
}
.friendly_link {
  width: 100%;
  border-top: 1px solid #dedede;
}
.friendly_link_con {
  width: 1200px;
  margin: auto;
  min-height: 100px;
  color: #181818;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.friendly_link_title {
  font-size: 18px;
  color: rgb(26, 127, 221);
}
.friendly_link_name {
  display: flex;
  justify-content: flex-start;
  margin-left: 40px;
}
.friendly_item {
  padding: 0 15px;
  margin: 5px 0px;
  border-right: 1px solid #ccc;
  font-size: 14px;
  cursor: pointer;
}
.friendly_item:hover{
    color: rgb(26, 127, 221);
}
.friendly_name {
  font-size: 14px;
  line-height: 26px;
}
.cooperation {
  margin-top: 100px;
}
.about_me {
  margin-top: 100px;
}
.about_news {
  margin: auto;
  width: 1200px;
  display: flex;
  gap: 10px;
}
.about_news_item {
  width: 300px;
  height: 420px;
  background: rgb(255, 255, 255);
  padding: 40px 30px;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}
.about_news_item:hover {
  background: rgb(221, 234, 247);
  animation-name: fadeInUp1;
  animation-duration: 1.3s;
}
.about_news_item:hover .about_news_time {
  background: #fff;
}
@keyframes fadeInUp1 {
  from {
    opacity: 1;
    -webkit-transform: translate3d(0, 8px, 0);
    transform: translate3d(0, 8px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.about_news_title {
  font-size: 18px;
  height: 46px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 50px;
}
.about_news_detail {
  font-size: 16px;
  height: 88px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.about_news_bot {
  /* position: absolute;
        top: 10px;
        left: 0; */
}
.about_news_time {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: #b4e0f9;
}
.about_news_time > span {
  position: absolute;
}
.about_news_time > span:nth-child(1) {
  left: 8px;
  top: 15px;
  font-size: 20px;
  font-weight: 600;
}
.about_news_time > span:nth-child(2) {
  display: inline-block;
  width: 1px;
  height: 70px;
  background: rgb(26, 127, 221);
  transform: rotateZ(45deg);
  left: 50px;
  top: 16px;
}
.about_news_time > span:nth-child(3) {
  left: 43px;
  top: 61px;
  font-size: 22px;
  font-weight: 600;
}
.about_news_link {
  /* text-decoration-line: underline; */
  color: rgb(26, 127, 221);
  position: absolute;
  bottom: 0;
  right: 10px;
}
.btn {
  width: 150px;
  height: 45px;
  background: rgb(26, 127, 221);
  color: #fff;
  text-align: center;
  line-height: 45px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin: 100px auto;
  border-radius: 5px;
  cursor: pointer;
}
</style>
<style scoped>
/deep/ .el-carousel__item.is-animating {
  -webkit-transition: -webkit-transform 1s ease-in-out;
  transition: -webkit-transform 1s ease-in-out;
  transition: transform 1s ease-in-out;
  transition: transform 1s ease-in-out, -webkit-transform 1s ease-in-out;
}
</style>
